import React from 'react';
import { useAuth } from '@soap/modules';
import logo from '../../z30-images/logo_lyw_200.png';
import '../styles/tailwind.css';

interface StandaloneLayoutProps {
  children: React.ReactNode;
  showHeader?: boolean; // Optional prop to show simplified header
}

export function StandaloneLayout({ children, showHeader = false }: StandaloneLayoutProps) {
  const { isAuthenticated } = useAuth("StandaloneLayout");
  
  // Show simplified header when not authenticated (external access via link/email)
  const shouldShowHeader = showHeader || !isAuthenticated;

  return (
    <div className="lyw-container min-h-screen bg-gray-50">
      {shouldShowHeader && (
        <header className="bg-white border-b border-gray-200 py-3 px-6">
          <div className="max-w-7xl mx-auto flex items-center gap-3">
            <img
              src={logo}
              alt="Learn Your Way"
              className="h-10 w-auto object-contain shrink-0"
            />
            <h1 className="text-xl font-semibold text-gray-900">Learn Your Way</h1>
          </div>
        </header>
      )}
      <main className="w-full">
        {children}
      </main>
    </div>
  );
}
